export const pilotNavItems = [
  { label: 'Mercado', href: '#mercado' },
  { label: 'Formação', href: '#formacao' },
  { label: 'Campo', href: '#campo' },
  { label: 'Investimento', href: '#investimento' },
] as const;

export const courseSignals = [
  {
    value: '5 dias',
    label: 'treinamento intensivo',
    detail: '24 a 28 de agosto',
  },
  {
    value: 'CAAR',
    label: 'teoria obrigatória',
    detail: 'habilitação MAPA',
  },
  {
    value: 'XAG P150',
    label: 'prática em campo',
    detail: 'operação assistida',
  },
  {
    value: '4 grupos',
    label: 'acesso direto ao drone',
    detail: 'prática acompanhada',
  },
] as const;

export const instructors = [
  {
    name: 'Marlon Soares Meireles',
    role: 'Direção Fronteira Sul Drones',
    description:
      'Une conhecimento técnico e vivência diária no agronegócio, com atuação em operação, atendimento a produtores e solução de desafios no campo.',
  },
  {
    name: 'Juliano Gonçalves Soares',
    role: 'Direção Fronteira Sul Drones',
    description:
      'Atua todos os dias no campo ajustando processos, equipamentos e rotinas para entregar operações mais seguras e eficientes.',
  },
  {
    name: 'Paulo Rosa',
    role: 'Pulverização agrícola',
    description: 'Referência nacional em pulverização, com mais de 30 anos de experiência.',
  },
  {
    name: 'Eduardo Mokan dos Anjos',
    role: 'Guri dos Drones',
    description: 'Influencer e comunicador do setor, conhecido como Guri dos Drones.',
  },
  {
    name: 'Rodrigo de Mattos',
    role: 'Piloto e instrutor',
    description:
      'Especialista em drones agrícolas e aplicação precisa de defensivos, acompanhando o aluno na realidade do treinamento.',
  },
] as const;

export const theoryModules = [
  'Características básicas das Aeronaves Remotamente Pilotadas',
  'Mercado de ARP no Brasil e usos na agricultura',
  'Legislação sobre ARP e agrotóxicos no Brasil',
  'Boas práticas agrícolas, toxicologia e uso de EPI',
  'Tecnologia de aplicação, teoria da gota e deriva',
  'Preparo de calda, carregamento, tríplice lavagem e descontaminação',
  'Fatores meteorológicos que influenciam as aplicações',
  'Planejamento operacional, segurança e calibração da ARP',
] as const;

export const practiceModules = [
  'Kit básico, abertura, fechamento e conhecimento do XAG P150',
  'Baterias, controle, app da XAG e conexão com RTK',
  'Mapeamento caminhando com RTK, por satélite e com o próprio drone',
  'Correção de mapa, entrada e saída na lavoura e configuração de radar',
  'Taxa variável, pulverização personalizada, manual e A/B',
  'Internet no celular durante a operação e rotina de retomada',
  'Calibração do tanque, retirada de ar das mangueiras e teste de motor',
  'Relatórios de voo e prática de todo o processo de pulverização',
] as const;

export const audienceItems = [
  'Quer aprender do zero e dominar a pulverização com drones agrícolas.',
  'Já pilota e deseja se profissionalizar para atuar com segurança e eficiência.',
  'Busca transformar conhecimento em uma nova fonte de renda no agro.',
  'Quer trabalhar como operador qualificado ou abrir o próprio negócio de pulverização.',
  'Deseja se atualizar com as tecnologias mais avançadas das plataformas XAG.',
] as const;

export const includedItems = [
  'Material didático completo',
  'Certificado de conclusão',
  'Suporte pós-curso',
  'Kit de brinde',
] as const;

export const investmentLots = [
  {
    name: '1º lote',
    price: 'R$ 3.800,00',
    note: 'melhor condição',
  },
  {
    name: '2º lote',
    price: 'R$ 4.500,00',
    note: 'lote intermediário',
  },
  {
    name: '3º lote',
    price: 'R$ 4.900,00',
    note: 'último lote',
  },
] as const;

export const importantNotes = [
  'Despesas com refeições e deslocamento são por conta do aluno.',
  'O não comparecimento não cancela nem altera os valores do treinamento.',
  'Não haverá reembolso total ou parcial, mesmo em caso de impedimento.',
  'Em situações de força maior comprovadas, será possível remarcar conforme disponibilidade de vagas.',
] as const;
